import { Dependencies } from 'interface/common.interface';
import { SMSConstraints, SMSStatePayload } from 'interface/sms/sms.type';

export interface SMSState {
  byRefId: {
    [refId: string]: SMSStateItem;
  };
  allRefId: string[];
}

export enum SMS_STORE_ACTION_TYPE {
  UPDATE_SMS = 'UPDATE_SMS',
}

export enum SMS_ACTION_TYPE {
  SMS = 'sms',
}

export interface SMSStateItem {
  refId: string;
  stepIdx: number;
  actionType: SMS_ACTION_TYPE;
  isOptional?: boolean;
  id?: string;
  name?: string;
  payload?: SMSStatePayload;
  payloadType?: 'template' | 'content';
  constraints?: SMSConstraints;
  dependencies?: Dependencies;
  templateId?: string;
  enableOptionalNode?: boolean; //UI
}
